@for (item of pages; track item) {
  <a [class]="item.type" [class.disabled]="isInactive(item)" [class.current]="isCurrent(item)"
    [tabIndex]="isInactive(item) ? -1 : 0" (click)="pageChange(item)" [attr.aria-label]="getAriaLabel$(item)">
    @if (isType(item) && item.type=='previous') {
      <span>
        <img src="icons/link_left-grey.svg" width="16" />
      Prev</span>
    }
    @if (isType(item)&&item.type=='next') {
      <span>Next
        <img src="icons/link-grey.svg" width="16" />
      </span>
    }
    @if (!isType(item)) {
      <span>{{ item.label}}</span>
    }
  </a>
}